import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'linkify',
  standalone: true
})
export class LinkifyPipe implements PipeTransform {
  transform(text: string): string {
    if (!text) return '';

    let html = text;

    // Escape < and >
    html = html.replace(/</g, '&lt;').replace(/>/g, '&gt;');

    // -------------------------------------------
    // 1️⃣ HANDLE MARKDOWN FIRST (bold, italic)
    // -------------------------------------------
    html = html.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
    html = html.replace(/_(.*?)_/g, '<em>$1</em>');

    // -------------------------------------------
    // 2️⃣ HANDLE MARKDOWN LINKS [text](url)
    // -------------------------------------------
    html = html.replace(
      /\[([^\]]+)\]\((https?:\/\/[^\s]+)\)/g,
      `<a href="$2" target="_blank" rel="noopener noreferrer" class="chat-link">$1</a>`
    );

    // -------------------------------------------
    // 3️⃣ HANDLE URLS (including inside <strong> or <em>)
    // -------------------------------------------
    // Matches URLs that may be wrapped inside tags
    const urlRegex = /(https?:\/\/[^\s<]+)/g;

    html = html.replace(
      urlRegex,
      (url) => `<a href="${url}" target="_blank" rel="noopener noreferrer" class="chat-link">${url}</a>`
    );

    // -------------------------------------------
    // 4️⃣ Line breaks → <br>
    // -------------------------------------------
    html = html.replace(/\n/g, '<br>');

    return html;
  }
}
